import { Controller } from '@hotwired/stimulus'

// Turbo 7 only marks frame forms aria-busy, not Drive form submissions.
export default class extends Controller {
  start() {
    this.element.setAttribute('aria-busy', 'true')
  }

  end() {
    this.element.removeAttribute('aria-busy')
  }
}
